import { useMemo } from 'react';
import { useAuth } from 'react-oidc-context';

import { config } from '../../../config/config';
import { useAllWalletCurrenciesQuery } from '../queries/currencies.graphql';
import { unique } from '../utils/arrays';
import { exists } from '../utils/filters';

export function useUserCurrencies() {
    const auth = useAuth();
    const userProfileId = auth.user?.profile?.user_profile_id;
    const [{ data, fetching }] = useAllWalletCurrenciesQuery({
        pause: !userProfileId,
        variables: {
            userProfileId: userProfileId as string,
            xTenantID: config.TENANT_ID,
        },
    });

    return useMemo(
        () => ({
            currencies: unique(
                data?.userWallets
                    ?.map((wallet) => {
                        return wallet?.currencyCode;
                    })
                    .filter(exists) ?? [],
            ),
            fetching,
        }),
        [data, fetching],
    );
}
